// libs
import { createTheme } from '@mui/material'
// themes
import colors from './colors'

export const THEME_OPTIONS: any = {
  palette: {
    primary: {
      light: colors.purple300,
      main: colors.purple300,
      dark: colors.purple300
    },
    secondary: {
      light: colors.red300,
      main: colors.red500,
      dark: colors.red800
    }
  },
  components: {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexDirection: 'column',
          minWidth: 240
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: colors.red300
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: colors.gray300,
          '&.Mui-disabled': {
            color: `${colors.gray300} !important`
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        text: {
          margin: '0px !important'
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            '&::before': {
              borderWidth: 2,
              borderColor: colors.red300
            }
          }
        }
      }
    },
    MuiMultiSectionDigitalClock: {
      styleOverrides: {
        root: {
          marginLeft: '16px'
        }
      }
    },
    MuiMultiSectionDigitalClockSection: {
      styleOverrides: {
        root: {
          width: '70px'
        }
      }
    }
  }
}

const STEPPER_THEME_OPTIONS = {
  ...THEME_OPTIONS,
  components: {
    MuiStepper: {
      styleOverrides: {
        horizontal: {
          padding: '0px'
        }
      }
    },
    MuiStep: {
      styleOverrides: {
        horizontal: {
          paddingLeft: '0px'
        },
        root: {
          '&.Mui-completed': {
            paddingRight: '0px'
          }
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {}
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          height: '46px',
          width: '46px',
          color: colors.gray270,
          boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.26)',
          borderRadius: '50%',
          '&.Mui-active': {
            color: `${colors.green600} !important`
          },
          '&.Mui-completed': {
            color: `${colors.green600} !important`
          }
        }
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          '&.Mui-active': {
            paddingLeft: '8px'
          },
          '&.Mui-completed': {
            display: 'none'
          }
        },
        label: {
          paddingLeft: '8px'
        },
        iconContainer: {
          paddingRight: '0px'
        },
        labelContainer: {
          maxWidth: '700px'
        }
      }
    }
  }
}

export const theme = createTheme(THEME_OPTIONS)
export const stepperTheme = createTheme(STEPPER_THEME_OPTIONS)

export { colors }
export * from './constants'
